"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textWithLineBreakFormatter = void 0;
function textWithLineBreakFormatter(text) {
    if (!text) {
        return '';
    }
    return text.replace(/\\n/g, '\n');
}
exports.textWithLineBreakFormatter = textWithLineBreakFormatter;
